import { ButtonVariants } from '@components/button/Button';
import { LinkStyledAsButton } from '@components/linkStyledAsButton/LinkStyledAsButton';

interface EmailSupportProps {
  label?: string;
  className?: string;
  testId?: string;
  to?: string;
}

export const EmailSupport = ({
  label = process.env.SUPPORT_EMAIL || 'Support email is missing',
  className,
  testId,
  to,
}: EmailSupportProps) => {
  const email = to || process.env.SUPPORT_EMAIL;

  return (
    <LinkStyledAsButton
      className={className}
      data-testid={testId}
      rel="noopener noreferrer"
      target="_blank"
      to={email ? `mailto:${email}` : '#'}
      variant={ButtonVariants.Tertiary}
      label={label}
    />
  );
};
